import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import './Articles.css';

export const ArticlesPage = () => {
    const featuredArticles = [
        {
            title: 'The Future of Insurance',
            description: 'Exploring emerging trends in the insurance industry and how they shape the future.',
            link: '/articles/future-of-insurance',
        },
        {
            title: 'How to Protect Your Business',
            description: 'Essential steps and tips for safeguarding your business assets and operations.',
            link: '/articles/business-protection',
        },
        {
            title: 'Navigating Health Insurance',
            description: 'A complete guide to understanding and choosing the best health insurance options.',
            link: '/articles/health-insurance-guide',
        },
    ];

    const articlesList = [
        {
            title: 'Understanding Commercial Insurance',
            description: 'A comprehensive guide to understanding commercial insurance, its benefits, and why businesses need it.',
            date: 'November 10, 2024',
            link: '/articles/commercial-insurance',
        },
        {
            title: 'The Importance of Personal Insurance',
            description: 'Why personal insurance matters and how to select the right coverage for you and your family.',
            date: 'October 25, 2024',
            link: '/articles/personal-insurance',
        },
        {
            title: 'Tips for Choosing Health Insurance',
            description: 'How to evaluate your options and choose the best health insurance plan for your needs.',
            date: 'October 15, 2024',
            link: '/articles/tips-for-health-insurance',
        },
        // Add more articles as needed
    ];

    return (
        <Container fluid className="articles-page">
            {/* Hero Section */}
            <div className="hero-section" style={{
                padding: '4rem 2rem',
                background: 'linear-gradient(135deg, #1e1e3f, #ff7f00)',
                color: '#fff',
                textAlign: 'center',
            }}>
                <Container style={{ maxWidth: '800px', margin: '0 auto' }}>
                    <h1 style={{ fontSize: '3rem', fontWeight: 'bold' }}>Insights & Resources</h1>
                    <p style={{ fontSize: '1.25rem', marginTop: '1rem' }}>
                        Stay updated with our latest articles on industry insights, tips, and resources to help you make informed decisions.
                    </p>
                </Container>
            </div>

            {/* Featured Articles Section */}
            <Container style={{ padding: '2rem 0' }}>
                <Row className="justify-content-center">
                    {featuredArticles.map((article, index) => (
                        <Col key={index} xs={12} md={4} lg={3} className="mb-4">
                            <Card className="article-card" style={{ borderRadius: '10px', boxShadow: '0px 4px 15px rgba(0, 0, 0, 0.1)', height: '100%' }}>
                                <Card.Body>
                                    <Card.Title style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#333' }}>{article.title}</Card.Title>
                                    <Card.Text style={{ fontSize: '1rem', color: '#555' }}>
                                        {article.description}
                                    </Card.Text>
                                    <Button href={article.link} variant="primary" style={{ marginTop: '1rem', display: 'flex', alignItems: 'center' }}>
                                        Read More <FontAwesomeIcon icon={faArrowRight} style={{ marginLeft: '0.5rem' }} />
                                    </Button>
                                </Card.Body>
                            </Card>
                        </Col>
                    ))}
                </Row>
            </Container>

            {/* List of Articles Section */}
            <Container style={{ padding: '2rem 0' }}>
                <Row>
                    {articlesList.map((article, index) => (
                        <Col key={index} xs={12} className="mb-4">
                            <Card style={{ padding: '1.5rem', borderRadius: '10px', boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)' }}>
                                <Card.Body>
                                    <Card.Title style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#333' }}>{article.title}</Card.Title>
                                    <Card.Text style={{ fontSize: '1rem', color: '#555' }}>
                                        {article.description}
                                    </Card.Text>
                                    <Card.Text style={{ fontSize: '0.875rem', color: '#777' }}>
                                        Published on {article.date}
                                    </Card.Text>
                                    <Button href={article.link} variant="link" style={{ color: '#007BFF', paddingLeft: '0', textDecoration: 'underline' }}>
                                        Read More
                                    </Button>
                                </Card.Body>
                            </Card>
                        </Col>
                    ))}
                </Row>
            </Container>
        </Container>
    );
}

export default ArticlesPage;
